import * as ShortId from 'shortid';

/**
 * A utility for generating Short IDs
 */
export class ShortIdUtil {
  /**
   * Generate a short ID
   * @returns A short ID string
   */
  public static generateId(): string {
    let id = ShortId.generate();
    while (id.indexOf('_') >= 0 || id.indexOf('-') >= 0) {
      id = ShortId.generate();
    }
    return id;
  }
}
